<template lang="pug">
.container
  page-header(
    :disable-back="true"
  )
  .page
    h2 Informationen zum Wettbewerb
  .inner
    .m-tabs.m-tabs--no-transition(data-g-name="Tabs")
      div(class="m-tabs__row")
        div(class="m-tabs__tabscontainer")
          button.m-tabs__tablink(:class="page == 1 ? 'state-active' : ''" @click="page=1")
            h2.a-headline
              span(class="newHomeTagNavigator__headerDecoration")
              | Aufgabe
          button.m-tabs__tablink(:class="page == 2 ? 'state-active' : ''" @click="page=2")
            h2.a-headline
              span(class="newHomeTagNavigator__headerDecoration")
              | Jury
          button.m-tabs__tablink(:class="page == 3 ? 'state-active' : ''" @click="page=3")
            h2.a-headline
              span(class="newHomeTagNavigator__headerDecoration")
              | Teilnehmende
          button.m-tabs__tablink(:class="page == 4 ? 'state-active' : ''" @click="page=4")
            h2.a-headline
              span(class="newHomeTagNavigator__headerDecoration")
              | Bürgerbeteiligung
          button.m-tabs__tablink(:class="page == 5 ? 'state-active' : ''" @click="page=5")
            h2.a-headline
              span(class="newHomeTagNavigator__headerDecoration")
              | Ablauf


        div(class="m-tabs__container")
          div(class="m-tabs__tabcontent" v-if="page==1")
            p.a-copy
              | Im Rahmen des im September 2022 gestarteten „Freiraumplanerischen Realisierungswettbewerb“ wurden sechs Landschaftsarchitekturbüros eingeladen, Ideen für die Gestaltung der Freiflächen des insgesamt über 20.000 Quadratmeter großen Areals zu entwickeln.
              br
              br
              | Im Mittelpunkt standen dabei neben allgemeinen Fragen des Designs, der Raumaufteilung sowie der Auswahl der notwendigen Materialien, Oberflächen und Farben auch zahlreiche weitere Aspekte. Sie umfassten sowohl die zukünftige Bepflanzung unter Berücksichtigung des Natur- und Artenschutzes sowie eine klimagerechte Anpassung an die zunehmenden Starkregenereignisse mit entsprechendem Regenwassermanagement als auch Punkte wie die Sicherheit oder die räumliche und funktionale Verknüpfung.
              br
              br
              | Zu den besonderen Herausforderungen zählte dabei insbesondere die Gestaltung der öffentlichen Räume, wie beispielsweise der Grünflächen oder der Freiflächen der hier geplanten Cafés, sowie die Anbindung an das bestehende Straßenverkehrs- und Fahrradwege-Netz. Auch der genaue Ort des Info-Pavillons wurde festgelegt. Dort können sich Interessierte und Anwohner/innen zukünftig über die Entwicklungen der Siemensstadt Square informieren. Weil ein Teil des Planungsgebiets zudem zum öffentlichen Straßenland des Landes Berlin zählt, trug der Wettbewerb auch den Anforderungen des Landes Rechnung.
          div(class="m-tabs__tabcontent" v-else-if="page==2")
            p.a-copy
              | Acht Fach- und Sachpreisrichter/innen sowie deren Stellvertreter/innen bildeten die Jury, die im Rahmen des Realisierungswettbewerbs zur Gestaltung der Freiflächen im zukünftigen Siemensstadt Square Entrée über die Entwürfe der teilnehmenden Landschaftsarchitekturbüros entschied. Auf Sachpreisrichter/innen-Seite war sie paritätisch mit Vertreter/innen des Landes Berlin und von Siemens besetzt. Ihnen zur Seite standen über 20 Sachverständige aus den verschiedensten Fachbereichen. Diese umfassten sowohl Themen des Verbraucher- und Klimaschutzes sowie der Nachhaltigkeit als auch der Sicherheit, Kultur- und Denkmalpflege, des Baurechts und vieles mehr.
              br
              br
              strong Fachpreisrichter/innen
              br
              br
              | • Juryvorsitz: Michael Kaschke, Landschaftsarchitekt, Hamburg
              br
              | • Carla Lo, Landschaftsarchitektin, Wien
              br
              | • Tobias Micke, Landschaftsarchitekt, Berlin
              br
              | • Marianne Mommsen, Landschaftsarchitektin, Berlin Sachpreisrichter/innen
              br
              | • Prof. Petra Kahlfeldt, Architektin, Senatsbaudirektorin und Staatssekretärin, Land Berlin
              br
              | • Thorsten Schatz, Bezirksstadtrat, Bezirksamt Spandau von Berlin
              br
              | • Stefan Kögl, Architekt, Siemens AG, Berlin
              br
              | • Jan Rehders, Architekt, Siemens AG, Berlin
              br
              br
              strong Stellvertretende Fachpreisrichterin
              br
              br
              | • Elisabeth Lesche, Landschaftsarchitektin, Berlin
              br
              br
              strong Stellvertretende Sachpreisrichter/innen
              br
              br
              | • Manfred Kühne, Abteilungsleiter, Senatsverwaltung für Stadtentwicklung und Wohnen, Land Berlin
              br
              | • Antje Uebelgünne, Fachbereichsleiterin Tiefbau, Straßen- und Grünflächenamt, Bezirksamt Spandau von Berlin
              br
              | • Egon Clesius, Siemens AG, Berlin
              br
              | • Thomas Preuner, Siemens AG, Berlin
          div(class="m-tabs__tabcontent" v-else-if="page==3")
            .paragraph.paragraph--type--html-app.paragraph--view-mode--default
              strong Greenbox Landschaftsarchitekten Schäfer + Pieper PartG mbB, Köln
              p Seit der Gründung im Jahr 2002 liegt der Schwerpunkt des Büros auf der Planung und Realisierung von Plätzen, Promenaden, Parks und Freiflächen im urbanen Kontext – mit nachhaltigen Konzepten, die auf die jeweiligen Bedürfnisse der Menschen und die Umgebung abgestimmt sind. Das Büro hat dabei individuelle Strategien für den öffentlichen Raum, Kultur- und Bildungseinrichtungen, Schwimmbäder, Sport- und Freizeitanlagen sowie für mittlere und große Unternehmen im In- und Ausland entwickelt.
              br
              strong GMO13 Landschaftsarchitekten, Berlin
              p Das 2013 in Berlin Kreuzberg gegründete Büro beschäftigt sich mit allen klassischen Bereichen der Landschaftsarchitektur im öffentlichen wie im privaten Raum. Neben der zukünftigen Stadt- und Landschaftsentwicklung unter Aspekten des gesellschaftlichen wie klimatischen Wandels sieht das Büro seinen Schwerpunkt im Entwurf anpassungsfähiger, vielfältiger und nicht alltäglicher Freiräume, die sich mit dem Leben und Wandel der Stadt und der Gesellschaft weiterentwickeln.
              br
              strong PLANSTATT SENNER, Überlingen
              p Im Laufe der letzten 30 Jahre hat sich der Bürogründer Johann Senner ein Expertenteam aus Landschaftsarchitekten, Naturwissenschaftlern, Ingenieuren und Kommunikationsexperten zusammengestellt, um anspruchsvolle Projekte bearbeiten zu können. Im Mittelpunkt der Arbeit stehen Zusammenhänge in der Natur wie auch in Siedlungsstrukturen, die in Einklang gebracht werden. Das Büro wurde bereits mehrfach ausgezeichnet, u.a. als Top-Innovator 2020.
              br
              strong Pola Landschaftsarchitekten, Berlin
              p Pola steht für poetische Landschaften und wird von dem Büro als Aufforderung an sich selbst verstanden, Orte zu gestalten, die Emotionen erzeugen, zu neuen Perspektiven einladen und als Gefühlslandschaften erlebt werden. Seit der Gründung im Jahr 2009 vereint das Büro Kompetenzen aus Freiraumgestaltung, Architektur, Bauingenieurwesen, Kommunikation und Geisteswissenschaften
              br
              strong Studio Polymorph, Berlin
              p Mit Interesse für Orte, deren Geschichte und Geschichten sowie einer großen Begeisterung für den Faktor Mensch versteht das Büro Landschaftsarchitektur als Angebot und Anreiz für menschliches Verhalten. Mit offenem Blick auf tatsächliche Potentiale und spezifische Bedürfnisse der Aufgabenstellung will das Büro Freiräume schaffen, bei denen Angemessenheit im Vordergrund steht: bei den Entwürfen wie bei den Herangehensweisen.
              br
              strong Topotek 1, Berlin
              p Das 1996 gegründete Büro versteht sich selbst als Wanderer in den Grenzbereichen von Typologien und Maßstäben, mit Abstechern in Städtebau, Musik und Kunst. Die entwickelten Konzepte zeichnen sich durch ein kritisches und neugieriges Verständnis der gegebenen Realitäten aus – zeitgenössisch, kulturell und historisch. Mit dem Ziel, zeitgemäße Räume für zeitgemäße Nutzungen zu schaffen, will das Büro Lösungen anbieten, die den modernen Anforderungen an Variabilität, Kommunikation und Sinnlichkeit gerecht werden.
              br
          div(class="m-tabs__tabcontent" v-else-if="page==4")
            .paragraph.paragraph--type--html-app.paragraph--view-mode--default
              p Wie bei den vorhergehenden Wettbewerben konnten sich auch diesmal die Bürger/innen wieder einbringen. Im September 2022 wurde im Rahmen eines Bürgerforums umfassend über den Wettbewerb, das Verfahren, die Teilnehmenden und die Vorgaben informiert. Parallel dazu starteten im September ein großer Online-Dialog (auf www.mein.berlin.de) sowie eine analoge Beteiligungsmöglichkeit, bei der Beiträge vor Ort in der Siemensstadt auf Postkarten eingereicht werden konnten. Alle Anregungen und Ideen aus den verschiedenen Beteiligungsformaten wurden gesammelt, aufbereitet und sind in die Auslobung eingeflossen.
              p 
                | Der Ergebnisbericht der Bürgerbeteiligung ist zudem öffentlich einsehbar unter 
                br
                | siemensstadt.siemens.com/de/beteiligung/chronik
              p: img(:src="require(`@/assets/img/qr.png`)")

          div(class="m-tabs__tabcontent" v-else-if="page==5")
            .paragraph.paragraph--type--html-app.paragraph--view-mode--default
              strong Ablauf
              ul
                li September 2022 – Bürgerbeteiligung (online und vor Ort)
                li 14. September 2022 – Preisrichterkolloquium
                li 28. September 2022 – Bürgerforum
                li 30. September 2022 – Versand der Auslobung, Start der Bearbeitungsphase
                li 11. Oktober 2022 – Teilnehmerkolloquium
                li 7. Dezember 2022 – Ende der Bearbeitungsphase, Abgabe der Entwürfe
                li 14.-16. Dezember 2022 – Sachverständigenprüfung
                li 11. Januar 2023 – Jury-Sitzung

 


</template>


<script>
export default {
  data(){
    return {
      page: 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



.m-tabs {
    position: relative;
}
.m-tabs--no-transition {
    opacity: 1 !important;
    -webkit-transition: none;
    transition: none;
    -webkit-transform: none;
    transform: none;
}
.m-tabs__row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
}
.m-tabs__tabscontainer {
    width: 100%;
}
@media (min-width: 900px) {
    .m-tabs__tabscontainer {
        max-width: 32.14286%;
    }
}
.m-tabs__container {
    width: 100%;
}
@media (min-width: 900px) {
    .m-tabs__container {
        max-width: 57.14286%;
    }
}
.m-tabs__tablink {
    position: relative;
    display: block;
    padding: 0 40px 24px 0;
    width: 100%;
    border: none;
    outline: none;
    text-align: left;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    background: transparent;
}
.m-tabs__tablink.state-active h2,
.m-tabs__tablink.state-active h3,
.m-tabs__tablink.state-active h4,
.m-tabs__tablink:hover h2,
.m-tabs__tablink:hover h3,
.m-tabs__tablink:hover h4 {
    color: #099;
}
.m-tabs__tablink h2,
.m-tabs__tablink h3,
.m-tabs__tablink h4 {
    color: #fff;
    display: inline;
}
@media (min-width: 900px) {
    .m-tabs__tablink h2,
    .m-tabs__tablink h3,
    .m-tabs__tablink h4 {
        color: #bbc5c5;
    }
}
.m-tabs__tablink:focus {
    outline: none;
}
@media (min-width: 900px) {
    .m-tabs__tablink {
        padding: 0 0 16px;
    }
}
@media (min-width: 900px) {
    .m-tabs__tablink.h-icon-plusminus:after,
    .m-tabs__tablink.h-icon-plusminus:before {
        content: none;
    }
}


.state-active span.newHomeTagNavigator__headerDecoration {
    width: 4px;
    position: absolute;
    left: -30px;
    top: 0.3rem;
    bottom: 0.1rem;
    background: -webkit-gradient(linear, left top, left bottom, from(#00ffb9), to(#00e6dc));
    background: linear-gradient(180deg, #00ffb9, #00e6dc);
}
.state-active span.newHomeTagNavigator__headerDecoration2 {
    border-width: 0 0 0 6px;
    border-left-style: solid;
    padding-left: 30px;
    -o-border-image: linear-gradient(180deg, #00ffb9, #00e6dc);
    border-image: -webkit-gradient(linear, left top, left bottom, from(#00ffb9), to(#00e6dc));
    border-image: linear-gradient(180deg, #00ffb9, #00e6dc);
    border-image-slice: 1;
}
h2.a-headline {
    font-size: 32px;
    font-weight: 400;
        position: relative;
}
</style>
